import listQuery from '../../../graphql/queries/customer/CustomerContactListQuery.graphql';
import fragment from '../../../graphql/fragments/customer/CustomerContactFragment.graphql';
import defaultQuery from '../../../graphql/queries/customer/CustomerContactDefault.graphql';
import mutationQuery from '../../mutations/customer/CustomerContactMutation.graphql';
import workspaceQuery from '../../../graphql/queries/customer/CustomerContactWorkspaceQuery.graphql';
import printCustomerContactDocumentSingleMutation from '../../../graphql/mutations/customer/PrintCustomerContactDocumentSingleMutation.graphql';
import printCustomerContactDocumentRangeMutation from '../../../graphql/mutations/customer/PrintCustomerContactDocumentRangeMutation.graphql';
import * as printFunctions from '../../../actions/customer/CustomerContactPrintActions';
import { customerContactDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { Direction, ReportType, ReportOutputType } from '../../schema/p4types';

const formActionsForPermissions = [
  {
    actionReference: 'CUSTOMER_CONTACT_LETTER',
  },
  {
    actionReference: 'CUSTOMER_CONTACT_MAILSHOT',
  },
  {
    actionReference: 'CUSTOMER_CONTACT_LABEL',
  },
];

const CustomerContact: EntityType = {
  type: 'CustomerContact',
  title: 'Customer Mailshots',
  screenReference: 'CUSTOMER_CONTACT',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name.fullName',
    customVariables: () => {
      return {
        orderBy: 'name',
        orderDirection: Direction.Asc,
        first: 200,
      };
    },
  },
  fragment,
  default: defaultQuery,
  update: mutationQuery,
  workspace: workspaceQuery,
  workspaceUrl: '/Customers/CustomerContact/Workspace/',
  generate: printCustomerContactDocumentSingleMutation,
  generateRange: printCustomerContactDocumentRangeMutation,
  printFunctions: printFunctions,
  mergeFields: customerContactDocument,
  actions: formActionsForPermissions,
};

export const CustomerContactLetter: EntityType = {
  ...CustomerContact,
  configuration: {
    title: 'Contact Letter',
    reportType: ReportType.CustomerContactLetter,
  } as any,
};

export const CustomerContactMailshot: EntityType = {
  ...CustomerContact,
  configuration: {
    title: 'Contact Mailshot',
    reportType: ReportType.CustomerContactMailshot,
    defaultConfig: {
      output: ReportOutputType.Email,
    } as any,
  },
};

export const CustomerContactLabel: EntityType = {
  ...CustomerContact,
  configuration: {
    title: 'Contact Label',
    reportType: ReportType.CustomerContactLabel,
  } as any,
};

export default CustomerContact;
